<template>
  <custom-dialog width="60%" :append-to-body="true" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body" style="padding: 0 24px">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" :placeholder="$t('components_device_select_dialog.qsrjsh')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table type="radio" v-model="selectedRow" :data="tableList" :column="tableColumn" @sort="sortChange" @filter="filterChange"></custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      tableCode: 'contractSelectDevice',
      formSearch: {
        sourceBodyNum: '',
        search: '',
        orderBy: '',
        productCode: '',
        // bizTypeList: [],
        orderType: '',
        pageSize: 50,
        pageNum: 1
      },

      selectedRow: {},
      tableList: [],
      totalRows: 0
    };
  },
  mounted() {
    this.getTableList();
    this.getTableColumn();

  },
  methods: {
    // 获取表格数据
    getTableList: function () {
      this.formSearch.sourceBodyNum = this.model.row.bodyNum;
      this.formSearch.productCode = this.model.row.productCode;
      // this.formSearch.bizTypeList = this.model.row.bizTypeList;
      this.$getJSON(apis.deviceBizStockPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 确认保存
    confirm: function () {
      this.visible = false;
      this.$emit('success', this.selectedRow);
    }
  }
};
</script>

<style lang="scss"></style>
